import type { HttpTypes } from "@medusajs/types"

export type CartPromotionPresentation = {
  incentive: {
    additional_quantity: number
    free_quantity: number
  } | null
  campaign: {
    label: string
    ends_at: string
  } | null
}

export type CartPendingAddPreview = {
  key: string
  title: string
  thumbnail: string | null
  quantity: number
  effectiveTotal: number
  compareAtTotal: number | null
  currencyCode: string
  bundleLabel: string | null
}

export type CartSnapshot = {
  cart: HttpTypes.StoreCart | null
  presentation: CartPromotionPresentation | null
  loadError: string | null
}

export type CartDrawerLine = {
  key: string
  lineId: string
  productId: string | null
  variantId: string
  quantity: number
  maxQuantity: number
  title: string
  catalogTitle: string
  handle: string | null
  thumbnail: string | null
  options: Array<{ name: string; value: string }>
  promotionLabels: string[]
  freeQuantity: number
  effectiveTotal: number
  compareAtTotal: number
  savings: number
}

export type CartDrawerViewModel = {
  lines: CartDrawerLine[]
  itemCount: number
  total: number
  savingsTotal: number
  currencyCode: string
  campaign: { label: string; endsAt: string } | null
  incentive: CartPromotionPresentation["incentive"]
}

export class CartMutationError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly reason?: "checkout_replaced_by_recovery" | "checkout_unavailable"
  ) {
    super(message)
    this.name = "CartMutationError"
  }
}

export const isCartConflict = (error: unknown): boolean =>
  error instanceof CartMutationError && error.status === 409

export const isCartReplacedByRecovery = (error: unknown): boolean =>
  error instanceof CartMutationError &&
  error.status === 409 &&
  error.reason === "checkout_replaced_by_recovery"

export const isCartUnavailable = (error: unknown): boolean =>
  error instanceof CartMutationError &&
  error.status === 409 &&
  error.reason === "checkout_unavailable"
